'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import PWAProvider from 'containers/PWAProvider'
import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect'
import Slots from 'pageContainers/AllGames/Games'
import BuilderTextContent from 'src/components/BuilderTextContent'
import Loader from 'src/components/Loader'
import { useAppDispatch } from 'src/store/hooks'
import { setTabsConfig } from 'src/store/modules/user/actions'
import { saveGameProducts } from 'store/modules/games/actions'

import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import type { Provider } from '@patrianna/shared-patrianna-types/store/ProviderModule'
import type { BuilderContent } from 'app/utils/builder'

export type Props = {
  games: GameProduct[]
  providersList: Provider[]
  content?: BuilderContent | null
  shouldBeRedirected?: boolean
  categories?: string[]
}

export default function ProviderPageClient({ games, content, shouldBeRedirected, categories }: Props) {
  const dispatch = useAppDispatch()
  const router = useRouter()

  useEffect(() => {
    if (games.length === 0 || shouldBeRedirected) {
      router.push('/slots')
    }
    dispatch(saveGameProducts({ games }))
    // eslint-disable-next-line
  }, [])

  useIsomorphicLayoutEffect(() => {
    if (categories) {
      dispatch(setTabsConfig({ tabsConfig: { categories, shouldBeRedirected } }))
    }
  }, [categories, dispatch, shouldBeRedirected])

  if (shouldBeRedirected) {
    return <Loader fullscreen />
  }

  return (
    <>
      <Slots games={games} isProviderGames={true} />
      {content && <BuilderTextContent content={content} model={process.env.PROVIDERS_DESCRIPTION} />}
      <PWAProvider />
    </>
  )
}
